import {
  initialState,
  Actions,
  State,
  NEW_SURVEY,
  NEW_SURVEY_SUCCESS,
  NEW_SURVEY_ERROR,
  RESET_NEW_SURVEY,
} from "../../types/survey/new";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_SURVEY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_SURVEY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_SURVEY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_SURVEY:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
